import {
  PM_GATE_DETAIL,
  PM_CHECKLIST,
  ADD_CATEGORY_TYPE,
  CATEGORY_TYPE,
  SUB_CATEGORY_TYPE,
  PM_GATE,
  SCHEDULED_TICKETS,
  ADD_CATEGORY_LIST,
  ENGINEER_LIST,
  PM_PROJECT_CHECKLIST
} from "./type";

const initalState = {
  pmListData: {},
  pmListChecklist: [],
  typeData: [],
  categoryType: [],
  subCategoryType: [],
  pmGateData: [],
  scheduledTickets: {},
  typeCategoryList: [],
  engineerListData: [],
  pmProjectChecklist:[]
};

const pmListReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PM_GATE_DETAIL:
      return {
        ...state,
        pmListData: payload,
      };
    case PM_CHECKLIST:
      return {
        ...state,
        pmListChecklist: payload,
      };
    case ADD_CATEGORY_TYPE:
      return {
        ...state,
        typeData: payload,
      };
    case CATEGORY_TYPE:
      return {
        ...state,
        categoryType: payload,
      };
    case SUB_CATEGORY_TYPE:
      return {
        ...state,
        subCategoryType: payload,
      };
    case PM_GATE:
      return {
        ...state,
        pmGateData: payload,
      };
    case SCHEDULED_TICKETS:
      return {
        ...state,
        scheduledTickets: payload,
      };
    case ADD_CATEGORY_LIST:
      return {
        ...state,
        typeCategoryList: payload,
      };
    case ENGINEER_LIST:
      return {
        ...state,
        engineerListData: payload,
      };
    case PM_PROJECT_CHECKLIST:
      return {
        ...state,
        pmProjectChecklist: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default pmListReducer;
